import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../../../utils/api'
import {
  ICreateTagBody,
  IGetListTagsResponse,
  IGetTagDetailResponse,
  IUpdateTagBody,
} from './tag-type'

export const BASE_TAG_URL = 'bo/tags'

export const useCreateTag = () => {
  const queryClient = useQueryClient()
  return useMutation<any, string, ICreateTagBody>(
    async body => {
      const { data } = await api.savvyGold.post(`${BASE_TAG_URL}`, {
        ...body,
      })
      return data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([BASE_TAG_URL])
      },
    },
  )
}

export const useUpdateTags = () => {
  const queryClient = useQueryClient()
  return useMutation<any, string, { tags?: IUpdateTagBody[] }>(
    async body => {
      const { data } = await api.savvyGold.put(`${BASE_TAG_URL}`, {
        ...body,
      })
      return data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([BASE_TAG_URL])
      },
    },
  )
}

export const useUpdateTag = (id: string) => {
  const queryClient = useQueryClient()
  return useMutation<any, string, { tags: IUpdateTagBody }>(
    async body => {
      const { data } = await api.savvyGold.put(`${BASE_TAG_URL}/${id}`, {
        ...body,
      })
      return data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([BASE_TAG_URL])
      },
    },
  )
}

export const useGetTags = (params?: { q?: string; page?: number }) => {
  return useQuery(
    [BASE_TAG_URL, params],
    async () => {
      const { data } = await api.savvyGold.get<IGetListTagsResponse>(BASE_TAG_URL, {
        page: params?.page,
        limit: 100,
        q: params?.q,
      })
      const result = data.data

      return result
    },
    {
      keepPreviousData: true,
      refetchInterval: 5 * 1000,
    },
  )
}

export const useGetTagById = (id: string) => {
  return useQuery(
    [BASE_TAG_URL, id],
    async () => {
      const { data } = await api.savvyGold.get<IGetTagDetailResponse>(`${BASE_TAG_URL}/${id}`)
      const result = data.data

      return result
    },
    {
      enabled: !!id,
    },
  )
}
